import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Packing as PackingType } from '../types'

export default function Packing() {
  return (
    <PaginaOperaciones<PackingType>
      titulo="Packing"
      recurso="packing"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'pickingFolio', titulo: 'Picking' },
        { campo: 'pedidoFolio', titulo: 'Pedido' },
        { campo: 'clienteNombre', titulo: 'Cliente' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fecha', titulo: 'Fecha', render: (p) => p.fecha?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Ejecutar',
          endpoint: (p) => `packing/${p.id}/ejecutar`,
          body: (p) => ({ id: p.id, estado: 'EnEjecucion' })
        },
        {
          label: 'Autorizar',
          endpoint: (p) => `packing/${p.id}/autorizar`,
          body: (p) => ({ id: p.id, estado: 'Autorizado' }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
